/* API module for BenutzerController */

import { api } from './http';
import { toApiError } from './errors';
import type {
  BenutzerCreateRequestDTO,
  BenutzerResponseDTO,
  BenutzerUpdateRequestDTO,
  ChangePasswordRequestDTO,
  ChangePasswordResponseDTO,
  RequestChangePasswordPinResponseDTO,
  RequestChangePasswordPinUnauthenticatedRequestDTO,
  ChangePasswordUnauthenticatedRequestDTO,
} from './types';

export type Id = number;

export async function getAll(): Promise<BenutzerResponseDTO[]> {
  try {
    const { data } = await api.get<BenutzerResponseDTO[]>('Benutzer');
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function getById(id: Id): Promise<BenutzerResponseDTO> {
  try {
    const { data } = await api.get<BenutzerResponseDTO>(`Benutzer/${id}`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function create(payload: BenutzerCreateRequestDTO): Promise<BenutzerResponseDTO> {
  try {
    const { data } = await api.post<BenutzerResponseDTO, BenutzerCreateRequestDTO>('Benutzer', payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function update(id: Id, payload: BenutzerUpdateRequestDTO): Promise<BenutzerResponseDTO> {
  try {
    const { data } = await api.put<BenutzerResponseDTO, BenutzerUpdateRequestDTO>(`Benutzer/${id}`, payload);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function toggleAdmin(id: Id): Promise<BenutzerResponseDTO> {
  try {
    const { data } = await api.patch<BenutzerResponseDTO>(`Benutzer/${id}/admin`);
    return data;
  } catch (e) {
    throw toApiError(e);
  }
}

export async function remove(id: Id): Promise<void> {
  try {
    await api.delete<void>(`Benutzer/${id}`);
  } catch (e) {
    throw toApiError(e);
  }
}

export async function requestChangePasswordPinUnauthenticated(payload: RequestChangePasswordPinUnauthenticatedRequestDTO): Promise<RequestChangePasswordPinResponseDTO> {
  try {
    const { data } = await api.post<RequestChangePasswordPinResponseDTO, RequestChangePasswordPinUnauthenticatedRequestDTO>('Benutzer/request-change-password-pin-unauthenticated', payload);
    return data;
  } catch (e: any) {
    if (e?.data && typeof e.data === 'object') {
      return e.data as RequestChangePasswordPinResponseDTO;
    }
    throw toApiError(e);
  }
}

export async function changePasswordUnauthenticated(payload: ChangePasswordUnauthenticatedRequestDTO): Promise<ChangePasswordResponseDTO> {
  try {
    const { data } = await api.post<ChangePasswordResponseDTO, ChangePasswordUnauthenticatedRequestDTO>('Benutzer/change-password-unauthenticated', payload);
    return data;
  } catch (e: any) {
    if (e?.data && typeof e.data === 'object') {
      return e.data as ChangePasswordResponseDTO;
    }
    throw toApiError(e);
  }
}

export async function requestChangePasswordPin(): Promise<RequestChangePasswordPinResponseDTO> {
  try {
    const { data } = await api.post<RequestChangePasswordPinResponseDTO>('Benutzer/request-change-password-pin');
    return data;
  } catch (e: any) {
    if (e?.data && typeof e.data === 'object') {
      return e.data as RequestChangePasswordPinResponseDTO;
    }
    throw toApiError(e);
  }
}

export async function changePassword(payload: ChangePasswordRequestDTO): Promise<ChangePasswordResponseDTO> {
  try {
    const { data } = await api.post<ChangePasswordResponseDTO, ChangePasswordRequestDTO>('Benutzer/change-password', payload);
    return data;
  } catch (e: any) {
    if (e?.data && typeof e.data === 'object') {
      return e.data as ChangePasswordResponseDTO;
    }
    throw toApiError(e);
  }
}
